import React, { Component } from "react";
import SettlementRateEntries from "../SettlementRate/SettlementRateEntries";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetch_settlementRates } from "../SettlementRate/redux/actions";
import "../SettlementRate/components/SettlementRateSelector.css";
import "./Admin.css";
import axios from "axios";
import { apiUri } from "../../config";
import Paginator from "../../hoc/Paginator/Paginator";
import { FaSearch } from "react-icons/fa";
import { NotificationManager } from "react-notifications";
import moment from "moment";

import "react-datepicker/dist/react-datepicker.css";

class SettlementRateManagement extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
			searchArray: [],
			currentSettlementRates: [],
			sortValue: "",
			sortOrder: "",
			searching: false,
			openAddModal: false,
			openImportModal: false,
			addCaseData: {
				comapnyName: "",
				riskAssessmentDate: moment(),
				riskAssessmentDate_UI: "",
				ticker: "",
				purchased: false,
				enabled: false,
				market: "",
				caseFile: "",
				identifier: "",
				sicCode: "",
				firmId: "",
				lastUpdated: "",
				dateAdded: "",
				indexListId: -1,
				comapnyNameError: "",
				riskAssessmentDateError: "",
				tickerError: "",
				sicCodeError: "",
				marketError: "",
				caseFileError: "",
				indexListIdError: "",
				identifierError: ""
			},
			indexList:[]
		};
		
		this.handleClick = this.handleClick.bind(this);
		this.updateSearchValue = this.updateSearchValue.bind(this);
		this.goToSettlementRateHandler = this.goToSettlementRateHandler.bind(this);
		this.handleSaveFileData = this.handleSaveFileData.bind(this);
		this.handleSaveStatus = this.handleSaveStatus.bind(this);
		this.handleClear = this.handleClear.bind(this);
		
		this.handleCreateCancel = this.handleCreateCancel.bind(this);
		
	}

	importLogs = (data) => {
		let self = this;
		localStorage.removeItem("timestamp");
		axios
			.get(apiUri + "/settlementRate/runImporter")
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
					NotificationManager.success(json.data.statusMessage, "Success");
				} else {
					NotificationManager.error(json.data.statusMessage, "Failure");
				}
			})
			.catch(err => {
				console.log(err);
			});
		this.setState({ openImportModal: true });
		var tmLoc = new Date();
		let T2 = tmLoc.getTime() + tmLoc.getTimezoneOffset() * 60000;
		localStorage.setItem("timestamp", T2);
		axios
			.get(apiUri + "/admin/getLogs")
			.then(json => {
				if (json.data) {
					self.setState({ logsData: json.data.content });
				}
			})
			.catch(err => {
				console.log(err);
			});
	};
	getLogs = () => { 
		let self = this;
		axios
			.get(apiUri + "/admin/getLogs") 
			.then(json => {
				if (json.data) {
					self.setState({ logsData: json.data.content });
				}
			})
			.catch(err => {
				console.log(err);
			});
	};

	goToSettlementRateHandler = settlementRateId => {
		this.props.history.push("/settlementRates/" + settlementRateId);
	};

	handleSaveFileData = (data, _onCloseModal) => {
	 
		if (data) {
			let RiskDate =
			new Date(data.riskAssessmentDate).getFullYear() +
			"-" +
			("0" + (new Date(data.riskAssessmentDate).getMonth() + 1)).slice(-2) +
			"-" +
			("0" + new Date(data.riskAssessmentDate).getDate()).slice(-2);
			let obj = {
				settlementRateId: data.settlementRateId,
				symbol: data.ticker,
				companyName: data.companyName,
				riskAssessmentDate: RiskDate,
				purchased: data.dateAdded,
				enabled: data.enabled,
				status: data.status,
				sicCode: data.sicCode,
				market: data.market,
				caseFile: data.caseFile,
				identifier: data.identifier,
				indexListId: data.indexListId
			};
			
			axios
			.put(apiUri + "/settlementRate/" + data.settlementRateId, obj)
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
					this.props.fetch_settlementRates(
						this.props.currentPage,
						this.state.sortValue,
						this.state.sortOrder
					);
					NotificationManager.success(json.data.statusMessage);
					_onCloseModal();
				}
			})
			.catch(err => {
				console.log(err);
			});
		}
	};
	handleSaveStatus = data => {
		if (data) {
			let obj = {
				settlementRateId: data.settlementRateId,
				enabled: data.enabled
			};
			axios
			.post(apiUri + "/settlementRate/updateEnabled", obj)
			.then(json => {
				if (json.data && json.data.statusCode === 200) {
				this.props.fetch_settlementRates(
					this.props.currentPage,
					this.state.sortValue,
					this.state.sortOrder
				);
				NotificationManager.success(json.data.statusMessage, "Success");
				}
			})
			.catch(err => {
				console.log(err);
			});
		}
	};
	

	onCloseModal = () => {
		this.setState({ open: false, openAddModal: false });
	};

	componentDidMount() {
		let page = this.props.currentPage;
		this.props.fetch_settlementRates(
			page,
			this.state.sortValue,
			this.state.sortOrder
		);
	};

	updateSearchValue(evt) {
		this.setState({ searchValue: evt.target.value });
	};

	handleClick() {
		localStorage.setItem("searchValue", JSON.stringify(this.state.searchValue));
		sessionStorage.setItem('tempSearchValue',this.state.searchValue)
		var obj = JSON.parse(localStorage.getItem("sortParams"));
		if(obj){
			this.setState({
				sortValue:obj.sortValue,
				sortOrder:obj.sortOrder
			})
			setTimeout(()=>{
				//this.props.searchSortData(this.props.currentPage, obj.sortValue, obj.sortOrder);
			},200) 
		}
	};

	handleClear() {
		this.setState({ searchValue: "" });
		localStorage.removeItem("sortParams");
		this.setState({sortOrder:'',sortValue:''})
		localStorage.removeItem("searchValue");
		sessionStorage.removeItem('tempSearchValue')
	};
	
	
	handleCreateCancel() {
		this.setState({ openAddModal: false, addCaseData: {} });
	}

	keyPress(e) {
		if (e.keyCode === 13 || e.keyCode === 10) {
			this.handleClick();
		}
	};
	componentDidUpdate(){
		window.onpopstate  = (e) => {
			e.preventDefault();
			var tempSearchValue = sessionStorage.getItem('tempSearchValue')

			if(tempSearchValue){
				setTimeout(()=>{
					localStorage.setItem("searchValue", JSON.stringify(tempSearchValue));
				},100)

				this.setState({ searchValue: tempSearchValue })

			}
			var obj = JSON.parse(localStorage.getItem("sortParams"));
			if(obj){
				this.setState({
					sortValue:obj.sortValue,
					sortOrder:obj.sortOrder
				})
				

				setTimeout(()=>{
					//this.props.searchSortData(this.props.currentPage, obj.sortValue, obj.sortOrder);
				},200) 
			}
		}
	};

	render() {
	
	return (
		<React.Fragment>
		<div
			style={{ display: "flex", justifyContent: "space-between" }}
			className={"CustomCaseManagementTitle"}
		>
			<span>Risk Tool Management</span>
			<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				width: "180"
			}}
			>
			<div
				style={{
				position: "relative",
				width: "207px",
				height: "29px",
				top: "-1px",
				backgroundColor: "#83bed3",
				border: "1px solid rgb(90, 154, 176)",
				borderRadius: "14.5px"
				}}
			>
				<input
				id="search"
				type="text"
				className="searchBox"
				onKeyDown={e => this.keyPress(e)}
				value={this.state.searchValue}
				placeholder="Search"
				onChange={this.updateSearchValue}
				/>
				{this.state.searchValue && (
				<span className="clearIcon" onClick={this.handleClear}>
					x
				</span>
				)}
				<FaSearch className="searchBtn" onClick={this.handleClick} />
			</div>
			&nbsp; &nbsp;
			<button
				className="btn btnS"
				onClick={() => {
				this.importLogs();
				}}
			>
				Import
			</button>
			</div>
		</div>
		{this.props.currentSettlementRates.length > 0 ? (
			<SettlementRateEntries
			settlementRates={this.props.currentSettlementRates}
			sortValue={this.state.sortValue}
			sortOrder={this.state.sortOrder}
			goToSettlementRateHandler={this.goToSettlementRateHandler}
			handleEdit={this.handleEdit}
			handleDelete={this.handleDelete}
			handleSaveFileData={this.handleSaveFileData}
			handleSaveStatus={this.handleSaveStatus}
			handleSorting={this.handleSorting}
			/>
		) : (
			<div className="widthfull">
			<table className="widthfull">
				<tbody>
				<tr>
				<td className="norecords">
					<span>No Records Found</span>
				</td>
				</tr>
				</tbody>
			</table>
			</div>
		)}
		{this.props.currentSettlementRates.length > 0 ? (
			<Paginator
				name={"case-selector"}
				totalPages={this.props.totalPages}
				currentPage={this.props.currentPage}
				setPage={this.props.fetch_settlementRates}
			/>
		) : (
			""
		)}
		</React.Fragment>
	);
	}
}

const mapStateToProps = state => {

	return {
		currentSettlementRates: state.settlementRateAdmin.currentSettlementRates,
		currentPage: state.settlementRateAdmin.currentPage,
		totalSettlementRates: state.settlementRateAdmin.totalCases,
		totalPages: state.settlementRateAdmin.totalPages
	};
};

const mapDispatchToProps = dispatch => {
	return {
	fetch_settlementRates: (page, sortValue, sortOrder) =>
		dispatch(fetch_settlementRates(page, sortValue, sortOrder))
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(SettlementRateManagement));



// WEBPACK FOOTER //
// ./src/components/Admin/SettlementRateManagement.js